document.addEventListener('DOMContentLoaded', function () {
  function customizeFormEmbed() {
    const formEmbed = document.querySelector('form-embed#app-embed');
    if (formEmbed && formEmbed.shadowRoot) {
      // Inject styles once
      const style = document.createElement('style');
      style.textContent = `
        [class*="formHeader"] {
          display: none !important;
        }

        form {
        gap: 30px !important;
        }

        ._inline_1q1d2_47 ._formContainer_1q1d2_30 {
          max-width: 750px !important;
        }

        label {
        top: 0 !important;
        position: relative !important; 
        left: 0 !important;
        color: black !important;
        order: -1 !important;
        }

        form > div {
    
        gap: 10px;
        }

        form > div:focus-within label {
        transform: none !important;
        left: 0 !important;
        }

        form > div input {
        padding: 2rem !important;
        box-shadow: none !important;
    border: 1px solid !important;
    border-radius: 0 !important;
        }

        :host {
        --input-label-transform: 0 !important;
        }

      `;
      formEmbed.shadowRoot.prepend(style);

      // First injection point
      const firstTarget = formEmbed.shadowRoot.querySelector('[name*="custom#manhattan_vintage_nyc_3_day_show"]');
      if (firstTarget) {
        const div1 = document.createElement('div');
        div1.innerHTML = `<h3>Top Message</h3><p>This appears before the form</p>`;
        firstTarget.parentNode.insertBefore(div1, firstTarget);
      }
    } else {
      setTimeout(customizeFormEmbed, 300); // Retry if not ready
    }
  }

  customizeFormEmbed();
});
